
























import {Component, Emit, Model, Prop, Watch} from "vue-property-decorator";
import {FreightServiceStore} from "@/modules/freightservices/store";
import debounce from "lodash/debounce";
import FreightServiceLabel from "@/modules/freightservices/List/components/Label.vue";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {CommonStatus} from "@/enums/status";
import {FreightService} from "@/interfaces/entity";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "FreightServiceSelector",
    components: {FreightServiceLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';
    @Model("change")
    readonly freightServiceRowGuid!: string | string[];

    @Emit('change')
    handleChange(value: string) {
        this.$emit('service', FreightServiceStore.data[value]);
        return value;
    }

    @Prop({default: false, type: Boolean})
    readonly disabled!: boolean;

    @Prop({default: "Chọn dịch vụ", type: String})
    readonly placeholder!: string;

    @Prop({default: "default", type: String})
    readonly mode!: string;

    @Prop({default: undefined, type: Number})
    readonly type!: number;

    @Prop({default: false, type: Boolean})
    readonly hasDefault!: boolean;

    @Prop({ default: undefined })
    readonly customerRowGuid!: string;

    @Prop({ default: false })
    readonly isAll!: boolean;

    freightServices: Array<FreightService> = [];

    get ids() {
        return FreightServiceStore.ids;
    }

    async created() {
        try {
            if (!this.isAll) {
                await this.getFreightServicesOfCustomer({});
            } else {
                await this.getFreightServices({
                    ...new FreightServiceParams(),
                    status: CommonStatus.Active
                });
            }
            if (this.hasDefault) {
                this.pickDefault();
            }
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã có lỗi xảy ra");
        }
    }

    @Watch('customerRowGuid')
    async onChangeCustomerRowGuid(val: any, oldVal: any) {
        if (val !== oldVal) {
            await this.getFreightServicesOfCustomer({
                ...{},
                customerRowGuid: val
            })
        }
    }

    async getFreightServices(params: any) {
        this.freightServices = await FreightServiceStore.listFreightService(params);
    }

    async getFreightServicesOfCustomer(params: any) {
        this.freightServices = await FreightServiceStore.listFreightServiceOfCustomer(params);
    }

    onSearch(val: any) {
        this.handleSearch(val, this);
    }

    handleSearch = debounce(async (value: string, vm: any) => {
        if (!this.isAll) {
            await vm.getFreightServicesOfCustomer({
                ...{},
                search: value,
                customerRowGuid: this.customerRowGuid ? this.customerRowGuid : undefined
            })
        } else {
            await vm.getFreightServices({
                ...new FreightServiceParams(),
                search: value,
                status: CommonStatus.Active
            });
        }
    }, 500);

    pickDefault() {
        if (this.freightServiceDefault)
            this.handleChange(this.freightServiceDefault as any);
    }
}
